import { render, staticRenderFns } from "./PackageSummaryNew.vue?vue&type=template&id=1f00f59c&scoped=true"
import script from "./PackageSummaryNew.vue?vue&type=script&lang=js"
export * from "./PackageSummaryNew.vue?vue&type=script&lang=js"
import style0 from "./PackageSummaryNew.vue?vue&type=style&index=0&id=1f00f59c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f00f59c",
  null
  
)

export default component.exports